import { combineReducers } from 'redux'

import * as common from '@h2/common/reducers'

import authenticationState from './reducers/authenticationState'
import personalProfile from './reducers/personalProfile'
import editPersonalProfile from './reducers/editPersonalProfile'
import signinOrRegisterDialog from './reducers/signinOrRegisterDialog'
import resetPassword from './reducers/resetPassword'
import collegePreferences from './reducers/collegePreferencesReducers'
import contentSnippetWizard from './reducers/contentSnippetWizard'
import louisianaIGP from './reducers/louisianaIGP'
import messageDialog from './reducers/messageDialog'
import pathwayProfile from './reducers/pathwayProfile'
import fileManagementWizard from './reducers/fileManagementWizard'
import clusterProfile from './reducers/clusterProfile'
import parentPortal from './reducers/parentPortal'
import parentRequest from './reducers/parentRequest'
import portfolioSummaryReport from './reducers/portfolioSummaryReport'
import admin from './reducers/admin'
import early from './reducers/early'
import profileCommon from './reducers/profileCommon'
import assessments from './reducers/assessments'
import clusterReport from './reducers/clusterReport'
import documentation from './reducers/documentation'
import profileView from './reducers/profileViewReducers'
import connectSearch from './reducers/connectSearchReducers'
import educatorportal from './reducers/educatorportal'
import surveys from './reducers/surveyReducer'
import profileForms from './reducers/profileForms'
import surveyEdit from './reducers/surveyEditReducer'
import pageInfo from './reducers/pageInfoReducers'
import announcements from './reducers/announcementsReducer'
import clusterListing from './reducers/clusterListing'
import occupations from './reducers/occupationsReducers'
import college from './reducers/college'
import industry from './reducers/industry'
import lmiRegions from './reducers/lmiregions'
import jobProfile from './reducers/jobProfile'
import modals from './reducers/modals'
import jobs from './reducers/jobs'
import combineAccounts from './reducers/combineAccountsReducers'
import cap from './reducers/capReducers'
import jobtools from './reducers/jobtools'
import planning from './reducers/planning'
import military from './reducers/military'
import mediaKit from './reducers/mediakit'
import jobZones from './reducers/jobZones'
import localOpportunities from './reducers/localOpportunities'
import survey from './reducers/surveyReducers'
import review from './reducers/review'
import miniHub from './reducers/miniHubReducers'
import myStuff from './reducers/myStuffReducers'
import educatorReferral from './reducers/educatorReferral'
import educatorAccountRequest from './reducers/educatorAccountRequest'
import search from './reducers/search'
import contact from './reducers/contact'
import internal from './reducers/internal/InternalReducer'

const root = combineReducers({
  contact,
  authenticationState,
  profileCommon,
  profileView,
  profileForms,
  connectSearch,
  modals,
  college,
  personalProfile,
  signinOrRegisterDialog,
  educatorportal,
  search,
  editPersonalProfile,
  mediaKit,
  resetPassword,
  military,
  survey,
  jobs,
  collegePreferences,
  contentSnippetWizard,
  messageDialog,
  louisianaIGP,
  pathwayProfile,
  documentation,
  fileManagementWizard,
  clusterProfile,
  clusterListing,
  parentPortal,
  lmiRegions,
  parentRequest,
  occupations,
  localOpportunities,
  portfolioSummaryReport,
  educatorAccountRequest,
  clusterReport,
  assessments,
  review,
  announcements,
  early,
  industry,
  surveys,
  surveyEdit,
  jobZones,
  pageInfo,
  admin,
  jobProfile,
  jobtools,
  educatorReferral,
  combineAccounts,
  cap,
  planning,
  miniHub,
  myStuff,
  internal,
  common: combineReducers(common)
})

export default (state, action) => {
  return root(state, action)
}
